import { useState, useEffect } from 'react'

/**
 * Hook do śledzenia statusu połączenia z internetem
 * @returns {boolean} Status połączenia z internetem (true = online, false = offline)
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Internet connection restored')
      setIsOnline(true)
    }

    const handleOffline = () => {
      console.log('🔌 Internet connection lost')
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return isOnline
}